import {
  ActionTypes as NewestItemsActionTypes,
  TypeKeys as NewestItemsTypeKeys
} from '../actions/home/fetchNewestItemsByCategory'
import {
  ActionTypes as HomeActionTypes,
  TypeKeys as HomeTypeKeys
} from '../actions/homePage'

import filterInappropriateTags from '../utils/filterInappropriateTags'

import { ISearchResults } from '../../typings/searchResults'
import { ISeoMetadata } from '../../typings/seoMetadata'

interface ISearchResultsByCategory {
  [propName: string]: ISearchResults | undefined
}

export interface IState {
  readonly newestItems: ISearchResultsByCategory
  readonly featuredItems?: ISearchResults
  readonly freeItems?: ISearchResults
  readonly metadata?: ISeoMetadata
  readonly newestItemsCategory: string
  readonly newestItemsPendingCategory?: string
}

const initialState: IState = {
  newestItems: { all: undefined },
  newestItemsCategory: 'all',
  featuredItems: undefined
}

export const reducer = (
  state = initialState,
  action: HomeActionTypes | NewestItemsActionTypes
): IState => {
  switch (action.type) {
    case HomeTypeKeys.GET_HOME_PAGE_API_SUCCESS:
      const newestItemsCategory = 'all'
      const newestItems = action.payload.newest_items
        ? {
            [newestItemsCategory]: filterInappropriateTags(
              action.payload.newest_items
            )
          }
        : { all: undefined }
      const featuredItems = action.payload.featured_items
      const freeItems = action.payload.free_items

      return {
        metadata: action.payload.metadata,
        newestItems,
        newestItemsCategory,
        featuredItems,
        freeItems
      }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING:
      return { ...state, newestItemsPendingCategory: action.payload.category }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        newestItems: {
          ...state.newestItems,
          [action.payload.category]: filterInappropriateTags(
            action.payload.searchResults
          )
        },
        newestItemsCategory: action.payload.category,
        newestItemsPendingCategory: undefined
      }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL:
      return {
        ...state,
        newestItemsPendingCategory: undefined
      }

    default:
      return state
  }
}
